export default __webpack_public_path__ + "static/media/libgif.8ebd01e1.gif";